import { Loading03Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { cn } from '@/lib/utils';

/**
 * A 14–16 px spinner for busy buttons and the "Refreshing" indicator. It is
 * decorative: the busy button's verb ("Approving…") carries the meaning. Pass
 * an aria-label to make it a status of its own. Never on an idle screen.
 */
function Spinner({
  className,
  'aria-label': ariaLabel,
  ...props
}: Omit<React.ComponentProps<'svg'>, 'strokeWidth'>) {
  return (
    <HugeiconsIcon
      icon={Loading03Icon}
      strokeWidth={2}
      data-slot="spinner"
      role={ariaLabel ? 'status' : undefined}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  );
}

export { Spinner };
